// Home.vue

<template>
  <v-container>
    <v-row class="text-center">
      <v-col cols="12">
        <v-img :src="require('../../../assets/CGRwebapp_logo.png')" class="my-3" contain height="200" />
      </v-col>
    </v-row>
    <v-row class="text-center">
      <!-- <v-col cols="12">
        <h1 >Bonjour {{$root.user.prenom}} {{$root.user.nom}}</h1>
      </v-col> -->
      
    </v-row>
    <v-row class="text-center">
      <v-col cols="12">
        <h2><v-badge v-bind:content="version" color="primary">Bienvenue sur CGR Webapp</v-badge></h2>
      </v-col>
    </v-row>
    <br/><br/>
    <v-row justify="center">
        <v-col cols="10" sm="10" md="6">
          <v-card :color="barColor" dark min-height="140" shaped to="/souscription/choixcategorieoffre">
            <v-card-title class="headline">Nouvelle souscription</v-card-title>
            <v-card-subtitle>Souscrire à une offre sur un nouveau contrat</v-card-subtitle>
          </v-card>
   
        </v-col>
    </v-row>
     
  </v-container>
</template>
<script>
import {AppService} from '../../../providers/AppService.js';
const appService = new AppService();
export default {
  name:'TlvHome',  
  data: () => ({
      barColor: "primary",
      version: null
  }),
  mounted: function () {
    this.version = appService.APP_VERSION;
    
     if(this.$root.user.univers != 'tlv')
      this.$root.logout(); 
  
  },
  methods: {
     
  }
};
</script>